import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "./App";
import { ThemeProvider } from "./modules/theme/ThemeContext";
import { initSentry } from "./modules/observability/sentry";
import { initPostHog } from "./modules/observability/posthog";
import "./index.css";

initSentry();
initPostHog();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div className="flex min-h-screen items-center justify-center px-6 text-center">
          <div className="max-w-md">
            <h1 className="text-sm font-semibold text-primary">
              Something broke.
            </h1>
            <p className="mt-2 text-xs text-muted">
              The crash was reported. Refresh to retry.
            </p>
            <pre className="mt-4 max-h-48 overflow-auto rounded-md border border-edge bg-surface-raised px-3 py-2 text-left font-code text-[0.625rem] text-faint">
              {error instanceof Error ? error.message : String(error)}
            </pre>
          </div>
        </div>
      )}
    >
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
